
// Reference Constants

var valueStepAmount = 10;
var valueLengthLimit = 4;


// Pure Helpers

function zeroIfNaN (n) {
  return n = isNaN(n) ? 0 : n;
}

function selectElementContents (el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}


//
// Voucher Configurator
//
// Choose from a range of preselected values, or enter your own.
//

module.exports = function VoucherConfigurator ($host, config) {

  // Dom

  var dom = {
    minus: $('[data-value-minus]',  $host),
    plus:  $('[data-value-plus]',   $host),
    input: $('[contenteditable]',   $host),
    focus: $('[data-focus-value]',  $host),
    value: $('[data-hidden-value]', $host),
  };


  // State

  var state = {
    previousValue: parseInt(config.defaultValue, 10),
    currentValue:  parseInt(config.defaultValue, 10)
  };


  // Functions

  function setValue (n) {
    //n = limitValueLength(n);
    state.currentValue = n;
    dom.input.text(n);
    dom.value.val(n);
  }

  function limitValueLength (n) {
    var text = n.toString(10);
    if (text.length > valueLengthLimit) return state.previousValue;
    state.previousValue = n;
    return n;
  }

  function setValueFromText () {
    var n = zeroIfNaN(parseInt(dom.input.text(), 10));
    state.currentValue = n;
    dom.value.val(n);
  }

  function setPresetValue (v) {
    setValue(Math.max(valueStepAmount, state.currentValue + v));
  }

  function focusInput () {
    selectElementContents(dom.input[0]);
  }


  // Listeners

  dom.minus.on('click', setPresetValue.bind(null, -valueStepAmount));
  dom.plus.on('click',  setPresetValue.bind(null, +valueStepAmount));
  dom.focus.on('click', focusInput);
  dom.input.on('blur focus keyup', setValueFromText);


  // Init

  setValue(state.currentValue);

}

